// khcmrt-v1: #e20b65
// khcmrt-v2: #faa73f
// khcmrt-v3: #008659
// khcmrt-v4: #FFDB00;

export const lines = [
  //v1
  {
    name: '紅線岡山路竹延伸線：第二A階段',
    variant: 'khcmrt-v1',
    info: '興建中，預計2027年完工通車',
  },
  //v1-1
  {
    name: '紅線岡山路竹延伸線：第二B階段',
    variant: 'khcmrt-v1',
    info: '尚未核定，僅供參考',
  },
  // v2
  {
    name: '捷運黃線：鳥松線',
    variant: 'khcmrt-v4',
    info: '施工中，預計2034年完工',
  },
  // v2-1
  {
    name: '捷運黃線：建工民族線',
    variant: 'khcmrt-v4',
    info: '施工中，預計2034年完工',
  },
  // v2-2
  {
    name: '捷運黃線：澄清五甲線',
    variant: 'khcmrt-v4',
    info: '施工中，預計2034年完工',
  },
  // v3
  {
    name: '捷運小港林園延伸線',
    variant: 'khcmrt-v3',
    info: '預計2024年底開工，2030年完工',
  },
]

export const stations = [
  [
    {
      name: '岡山農工站 RK2',
      address: '',
      lat: 22.801681,
      lng: 120.292084,
    },
    {
      name: '本洲產業園區站 RK3',
      address: '',
      lat: 22.812354,
      lng: 120.272432,
    },
    {
      name: '高雄科學園區站 RK4',
      address: '',
      lat: 22.829499,
      lng: 120.26382,
    },
    {
      name: '台鋼科技大學站 RK5',
      address: '',
      lat: 22.841206,
      lng: 120.263907,
    },
    {
      name: '南路竹站 RK6',
      address: '',
      lat: 22.849455,
      lng: 120.262301,
    },
  ],
  // v1-1
  [
    {
      name: 'RK7',
      address: '',
      lat: 22.854257,
      lng: 120.261167,
    },
    {
      name: 'RK8',
      address: '',
      lat: 22.880738,
      lng: 120.279747,
    },
  ],
  // v2 捷運黃線：鳥松線
  [
    {
      name: '坔埔站 Y1',
      address: '',
      lat: 22.658654,
      lng: 120.381421,
    },
    {
      name: '崎子腳站 Y2',
      address: '',
      lat: 22.659426,
      lng: 120.369114,
    },
    {
      name: '鳥松站 Y3',
      address: '',
      lat: 22.657762,
      lng: 120.359076,
    },
    {
      name: '長庚醫院站	Y4',
      address: '',
      lat: 22.650223,
      lng: 120.355623,
    },
    {
      name: '澄清湖站 Y5',
      address: '',
      lat: 22.650621,
      lng: 120.348347,
    },
  ],
  // v2-1 捷運黃線：建工民族線
  [
    {
      name: '大華站 Y6',
      address: '',
      lat: 22.651742,
      lng: 120.341077,
    },
    {
      name: '本館站 Y7',
      address: '',
      lat: 22.6556,
      lng: 120.336029,
    },
    {
      name: '高雄高工站 Y8',
      address: '',
      lat: 22.650234,
      lng: 120.32493,
    },
    {
      name: '大港站 Y9',
      address: '',
      lat: 22.644772,
      lng: 120.3141,
    },
    {
      name: '民族站 Y10',
      address: '',
      lat: 22.640509,
      lng: 120.314056,
    },
    {
      name: '信義國小站 Y11',
      address: '',
      lat: 22.63116,
      lng: 120.310555,
    },
    {
      name: '四維行政中心站 Y12',
      address: '',
      lat: 22.621772,
      lng: 120.312721,
    },
    {
      name: '三多市場站 Y13',
      address: '',
      lat: 22.616368,
      lng: 120.311759,
    },
    {
      name: '三多商圈站 Y14',
      address: '',
      lat: 22.613542,
      lng: 120.304543,
    },
    {
      name: '旅運中心站	Y15',
      address: '',
      lat: 22.61202,
      lng: 120.293679,
    },
  ],
  // v2-2 捷運黃線：澄清五甲線
  [
    {
      name: '寶業滯洪公園站 Y16',
      address: '',
      lat: 22.64031,
      lng: 120.345445,
    },
    {
      name: '正義站 Y17',
      address: '',
      lat: 22.634204,
      lng: 120.342678,
    },
    {
      name: '衛武營站 Y18',
      address: '',
      lat: 22.626579,
      lng: 120.339785,
    },
    {
      name: '新甲站 Y19',
      address: '',
      lat: 22.617503,
      lng: 120.34551,
    },
    {
      name: '七老爺站 Y20',
      address: '',
      lat: 22.606645,
      lng: 120.345653,
    },
    {
      name: '五甲站 Y21',
      address: '',
      lat: 22.599059,
      lng: 120.337207,
    },
    {
      name: '龍成宮站 Y22',
      address: '',
      lat: 22.593432,
      lng: 120.328358,
    },
    {
      name: '前鎮高中站 Y23',
      address: '',
      lat: 22.589216,
      lng: 120.322142,
    },
  ],
  // v3 捷運小港林園延伸線
  [
    {
      name: '中鋼東門 RL1',
      address: '',
      lat: 22.55438,
      lng: 120.362263,
    },
    {
      name: '中林站 RL2',
      address: '',
      lat: 22.541063,
      lng: 120.371498,
    },
    {
      name: '鳳鼻頭 RL3',
      address: '',
      lat: 22.51637,
      lng: 120.362976,
    },
    {
      name: '中坑門 RL4',
      address: '',
      lat: 22.509536,
      lng: 120.365571,
    },
    {
      name: '港子埔 RL5',
      address: '',
      lat: 22.503947,
      lng: 120.378047,
    },
    {
      name: '林園 RL6',
      address: '',
      lat: 22.500615,
      lng: 120.397961,
    },
    {
      name: '林園工業區 RL7',
      address: '',
      lat: 22.498973,
      lng: 120.407152,
    },
  ],
]
